<template>
  <OverlayLoader :visible="isLoading" />
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4" >
        <form class="position-relative table-src-form me-0" @submit.prevent>
          <div class="row">
            <div class="col-lg-3 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Nombre</label>
                <input
                  type="text" v-model="filters.name"
                  class="form-control h-55"
                  placeholder="Ingrese nombre"
                />
              </div>
            </div>
            <div class="col-lg-4 col-sm-6 text-end mt-4">
              <div class="d-inline-flex flex-wrap gap-3 justify-content-end">
                <button type="button" @click.prevent="getPlaysRepository()" 
                  class="btn btn-outline-primary  py-1 px-3 fw-medium fs-14 hover-bg">
                  Buscar
                </button>
                <RouterLink to="/repository/create">
                  <button type="button" class="btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg">
                    <span class="py-sm-1 d-block">
                      <span>Agregar Jugada</span>
                    </span>
                  </button>
                </RouterLink>
              </div>
            </div>
          </div>
        </form>
        
      </div>

      <div class="default-table-area style-two default-table-width">
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th scope="col" >#</th>
                <th scope="col" class="text-center">Nombre de Jugada</th>
                <th scope="col" class="text-center">Nro. Acciones</th>
                <th scope="col" class="text-center">Creado<br> por</th>
                <th scope="col" class="text-center">Fecha <br>creación</th>
                <th scope="col" class="text-center">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in items" :key="item.id">
                <td>
                  {{
                      (index + 1)  
                  }}
                </td>
                <td>{{ item.playName }}</td>
                <td>{{ item.items.length }}</td>
                <td class="text-body">{{ item.createdBy }}</td>
                <td class="text-body">{{ item.createdAtDateTimeString}}</td> 
                <td  class="text-center">
                  <RouterLink :to="`/repository/create/${item.id}`"  >
                    <button class="ps-2 border-0 bg-transparent lh-1 position-relative"  :disabled="item.matchId != null"
                    >
                      <i class="material-symbols-outlined fs-16  ps-2 " :class="{'text-default' : item.matchId != null, 'text-primary' : item.matchId == null}">
                        settings
                      </i>
                    </button>
                  </RouterLink>
                  <button class="border-0 bg-transparent lh-1 position-relative" 
                    @click="playActionsModal(item.id)"
                  >
                    <i class="material-symbols-outlined fs-16 text-primary">
                      lists
                    </i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
 
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div id="mdlPlayActions"
    class="modal fade" tabindex="-1" aria-labelledby="mdlPlayActionsLabel"
    aria-hidden="true" size="large"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlPlayActionsLabel">
            Jugada {{play.playName}} - Acciones
          </h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
        </div>
        <div class="modal-body">
          <div class="default-table-area style-two default-table-width">
            <div class="table-responsive">
              <table class="table align-middle">
                <thead>
                  <tr>
                    <th scope="col" class="text-center"></th>
                    <th scope="col" class="text-center">Orden</th>
                    <th scope="col" class="text-center">Tipo</th>
                    <th scope="col" class="text-center">Detalle</th>
                    <th scope="col" class="text-center">Tipo de Pregunta</th>
                    <th scope="col" class="text-center">Nro. Opciones</th> 
                    <th scope="col" class="text-center">Opciones</th> 
                  </tr>
                </thead>
                <draggable
                    v-if="playItems.length"
                    v-model="playItems"
                    item-key="id"
                    tag="tbody"
                    handle=".drag-handle"
                    :animation="200"
                    @end="updateOrderItems"
                  >
                    <template #item="{ element: item }">
                      <tr :key="item.id">
                        <td class="text-body text-right drag-handle">
                          <i class="material-symbols-outlined fs-16 text-primary cursor-move">drag_indicator</i>
                        </td>
                        <td class="text-body text-right "> {{ item.order }}</td>
                        <td class="text-body">{{ item.playType }}</td>
                        <td v-html="limitHtmlContent(item.description)"  :title="stripHtmlAndLimit(item.description)"></td>
                        <td class="text-body text-center">{{ item.questionType ?? '-' }}</td>
                        <td class="text-body text-right">{{ item.totalOptions ?? '-' }}</td>
                        <td class="text-center">
                          <RouterLink :to="`/repository/${item.playTypeId == PLAY_TYPES.QUIZ ? 'question' : 'content'}/edit/${item.id}`"  
                            @click="modalPlayActions.hide();"
                          >
                            <i class="material-symbols-outlined fs-16 text-primary">
                              edit
                            </i>
                          </RouterLink>
                          <button
                            class="ps-2 border-0 bg-transparent lh-1 position-relative"
                            @click="removedPlay(item.playTypeId, item.id)"
                          >
                            <i class="material-symbols-outlined fs-16 text-primary">delete</i>
                          </button>
                        </td> 
                      </tr>
                    </template>
                </draggable>
              
              </table>
            </div>

            <div class="p-4 pt-lg-4">
              
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger text-white"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { defineComponent, ref, onMounted } from "vue"; 
import OverlayLoader from '@/components/Others/OverlayLoader.vue';
import Swal from 'sweetalert2';
import { useToast } from "vue-toastification";
import api from '@/services/api';
import {PAGINATION_ITEMS_PER_PAGE, STATUS, LABELS, PLAY_TYPES}  from "@/utils/constants";
import htmlTruncate from 'html-truncate'; 
import draggable from 'vuedraggable'

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Repository",
  components: {
    OverlayLoader , draggable
  },
  setup() {
    
    const isLoading = ref(false); 
    const pageSize = ref(PAGINATION_ITEMS_PER_PAGE);
    const totalItems = ref(0);
    const toast = useToast();

    const itemsPlayTypes = ref<any[]>([]);
    const itemsTournament = ref<any[]>([]);
    const itemsMatch = ref<any[]>([]);
    const items = ref<any[]>([]);
    const play = ref<any>({}); 
    const playItems = ref<any[]>([]);
    const filters = ref({
      playTypeId: null,
      name:'',
      isActive: null
		}); 

    const computeStatusClass = (classValue: boolean) => {
      return {
        shipped: classValue,
        deactive: !classValue,
      };
    };

    const modalPlayActions = ref<any>(null);

    onMounted(async () => {
      
      await getPlayTypes();
      await getPlaysRepository();

      const modalElement = document.getElementById('mdlPlayActions');
      if (modalElement && window.bootstrap) {
        modalPlayActions.value = new window.bootstrap.Modal(modalElement);
        modalPlayActions.value.hide();
      }
            
    });

    const getPlayTypes = async() => {
        try {
          const response = await api.get(`/common/play-types`);
          itemsPlayTypes.value = response.data;
        }catch(ex){
          console.error(ex);
        }
    };

    const getPlaysRepository = async() => {
      try {
        isLoading.value = true;

        const response = await api.get(`/play/repository`);
        
        items.value = response.data; 
      } catch (error) {
        console.error(error);
      }finally{
        isLoading.value = false;
      }
    };

    const confirmChangeStatus = async (id: number, status: boolean) => {
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>${status ? 'desactivar': 'activar'}</b> el Tipo de Jugada?`, 
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sí, ${status ? 'desactivar': 'activar'} `,
        cancelButtonText: 'Cancelar',
      });
      
      if (result.isConfirmed) {
        isLoading.value = true;

        var obj = {
          "id": id,
          "status": !status
        }

        const response: any = await api.put(`/play-type`, obj);
        
        if(response != 0){
          toast.success(`El Tipo de Jugada fue ${status ? "desactivada" : "activada" } con éxito.`, {
            timeout: 2000
          });
          getPlaysRepository( )
        }else{
          toast.error(`El Tipo de Jugada no pudo ser ${status ? "desactivada" : "activada" }.`, {
            timeout: 2000
          });
        }
        isLoading.value = false;
      }
    };
    
    const stripHtmlAndLimit = (html: string ) =>{
      const temp = document.createElement('div');
      temp.innerHTML = html;
      const text = temp.textContent || temp.innerText || '';
      return  text;
    }

    const limitHtmlContent = (html: string, maxLength = 200)  =>{
      return htmlTruncate(html, maxLength, { keepImageTag: false }) ;
    }

    const getPlayConfig= async(id: any) => {
      try {
        isLoading.value = true; 

        const response = await api.get(`/play/${id}/config`);
        return response;

      } catch (error) {
        console.error(error);
      }finally{
        isLoading.value = false;
      }
    };
    const playActionsModal= async (id: number) => {
      
      try {
        play.value = items.value.find(f => f.id === id);

        const response = await getPlayConfig(id);
        if(response != null){
          playItems.value = response.data.items;
        }
        
        modalPlayActions.value.show();

      }catch(ex){
        
        console.error(ex);
      }

    }

    const removedPlay = async (playTypeId: number, id: number) => {
      
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>eliminar</b> la Jugada?`, 
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sí, eliminar`,
        cancelButtonText: 'Cancelar',
      });
      
      if (result.isConfirmed) {
        isLoading.value = true;

        var playId = play.value.id ;
        const payload = {
          "playTypeId": playTypeId,
          "id": id,
        };
        
        const response: any = await api.post(`/play/${playId}/remove`, payload);

        if(response != 0){
          
          const response = await getPlayConfig(playId);
          if(response != null){
            playItems.value = response.data.items;
          }
          await updateOrderItems();
          toast.success(`La Jugada fue desactivada con éxito.`, {
            timeout: 3000
          });
        }else{
          toast.error(`La Jugada no pudo ser desactivada.`, {
            timeout: 3000
          });
        }
        isLoading.value = false;
      }
    };

    const updateOrderItems = async() => {
      playItems.value.forEach((item, index) => {
        item.order = index + 1;
      });

      isLoading.value = true;

      var playId =play.value.id ;
      try {
  
        const response: any = await api.put(`/play/${playId}/update-order`, playItems.value);
        isLoading.value = false;

        if(response.data){ 
          toast.success(`Se actualizó el orden de las jugadas.`, {
            timeout: 2000
          });

        }

      }catch(ex){
        toast.error("El orden de las jugadas no pudo ser actualizado.", {
          timeout: 2000
        });
        console.error(ex);
        isLoading.value = false;

      }
    };

    return {
      items, 
      itemsPlayTypes,
      itemsTournament,
      itemsMatch, 
      pageSize,
      totalItems,
      STATUS, PLAY_TYPES, LABELS, OverlayLoader,
      filters,
      isLoading,
      computeStatusClass, 
      getPlaysRepository, 
      confirmChangeStatus,
      stripHtmlAndLimit,
      limitHtmlContent,
      playActionsModal,
      play, playItems, removedPlay,modalPlayActions,updateOrderItems,draggable
    };
  },
});
</script>
